import type {IApiErrorPayload} from '../types';

/** Тело ошибки бывает и HTML-строкой (502 от шлюза, заглушка WAF) — читаем только объекты. */
export function readApiMessageEn(data: unknown): string | undefined {
    if (typeof data !== 'object' || data === null) return undefined;
    const payload = data as IApiErrorPayload;
    return payload.error?.messageEn ?? payload.error?.message ?? payload.message;
}
